// extracted by mini-css-extract-plugin
export default {"Title":"CandidateInfo_Title__tjqy+","DegreeTitle":"CandidateInfo_DegreeTitle__GZllW"};